import { Navigate, Outlet } from "react-router-dom";
import useAuth from "../context/useAuth";
import { getAccessToken } from "../utils/cookies";
import { getDefaultRouteForRole } from "./authRedirects";

const ProtectedRoute = ({ allowedRoles }) => {
  const { user } = useAuth();
  const token = getAccessToken();
  const numericRole = Number(user?.role);

  if (!token) return <Navigate to="/" replace />;

  if (
    Array.isArray(allowedRoles) &&
    allowedRoles.length > 0 &&
    !allowedRoles.map(Number).includes(numericRole)
  ) {
    return <Navigate to={getDefaultRouteForRole(numericRole)} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
